import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';
import { colorScheme } from '../../theme';

export const StyledDropdown = styled(Dropdown)`
  flex: 1;
  flex-grow: 1;
  display: inline-flex;
  justify-content: center;
  align-items: stretch;

  .dropdown-toggle::after {
    align-self: center;
  }

  && .dropdown-menu.show {
    opacity: 1;
    pointer-events: auto;
  }

  && .dropdown-toggle {
    background: ${colorScheme.input.background};
    border-color: ${colorScheme.input.border};
    color: ${colorScheme.input.text};
  }
`;
